import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import MyPagination from "src/components/common/MyPagination";
import ListHead from "src/components/common/ListHead";
import CellImage from "src/components/common/CellImage";
import ListToolbar from "src/components/common/ListToolbar";
import { asyncRequest } from "src/services/network";
import QRCode from "qrcode";
import AccountTransactionsDialog from "./components/AccountTransactionsDialog";

const typeMap = { "01":"基本户", "02":"现金户", "03":"延时户", "04":"钱包户", "05":"充值户", "09":"营销户", }
const statusMap = { N: "正常", C: "关闭", F: "冻结", D: "销户" }

const TABLE_HEAD = [
  { id: "id", label: "序号", alignRight: false }, 
  { id: "accountId", label: "账户号", alignRight: false }, 
  { id: "acct_type", label: "账号类型", alignRight: false }, 
  { id: "balance_amt", label: "余额", alignRight: false }, 
  { id: "avl_bal", label: "可用余额", alignRight: false }, 
  { id: "frz_bal", label: "冻结余额", alignRight: false }, 
  { id: "last_avl_bal", label: "昨日日终余额", alignRight: false }, 
  { id: "acct_stat", label: "状态", alignRight: false }, 
  { id: "" }
];

const moreMenus = [{ title: "财务流水", icon: iconDelete }];

export default function HuifuAccounts() {
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const [action, setAction] = useState("");
  const [targetAccount, setTargetAccount] = useState({});

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "finance/huifu/accounts",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "财务流水") {
      setTargetAccount(row);
      setAction('logs')
    }
  };

  const isUserNotFound = items.length === 0;

  return (
    <Page title="资金账户">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            资金账户
          </Typography>

          {/* <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddTopup}>
            添加订单
          </Button> */}
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />

                <TableBody>
                  {items.map((row, index) => {
                    const { id, acct_id, acct_type, last_avl_bal, icon, share, balance_amt, avl_bal, frz_bal, acct_stat } = row;
                    const isItemSelected = selected.indexOf(icon) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell align="left">{acct_id}</TableCell>
                        <TableCell align="left">{typeMap[acct_type]}</TableCell>
                        <TableCell align="left">{balance_amt}</TableCell>
                        <TableCell align="left">{avl_bal}</TableCell>
                        <TableCell align="left">{frz_bal}</TableCell>
                        <TableCell align="left">{last_avl_bal}</TableCell>
                        <TableCell align="left">{statusMap[acct_stat]}</TableCell>
                        {/* <TableCell align="left">{moment(payTime).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}

                        <TableCell align="right">
                          <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
                
      {action == 'logs' && (
        <AccountTransactionsDialog accountId={targetAccount.acct_id} open onClose={() => setAction('')} />
      )}
    </Page>
  );
}
